import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Config from '../../../Config';
import { selectEpiImagesSet, getEpiFolderName } from './getEpiFolderImages'; 

const resolvedUrlsCache = new Map();

export const useResolveImageUrl = (src) => {
  const epiImagesSet = useSelector(selectEpiImagesSet);
  const folder = useSelector(getEpiFolderName);

  function getCleanPath(input) {
    let path = input;
    if (input.startsWith('http://') || input.startsWith('https://')) {
        path = new URL(input).pathname;
    }
  return path.startsWith('/') ? path.substring(1) : path;
}

  return useMemo(() => {
    const raw = (src && typeof src === 'object' && 'default' in src) ? src.default : src;
    
    const assetUrl = typeof raw === 'string' ? raw : String(raw || '');

    if (assetUrl.includes(Config.epiBaseUrl) || assetUrl.includes('globalassets')) {
      return { finalSrc: assetUrl, SvgComponent: null };
    }

    // if (resolvedUrlsCache.has(assetUrl)) {
    //   return { finalSrc: resolvedUrlsCache.get(assetUrl), SvgComponent: null };
    // }

    let finalPath = assetUrl;
    let normalized = getCleanPath(assetUrl);

    if (epiImagesSet.has(normalized)) {
      const transformedName = normalized.replaceAll("/", "___");
      finalPath = `${Config.epiBaseUrl}/globalassets/${folder}/${transformedName}`;
     // resolvedUrlsCache.set(assetUrl, finalPath);
      return { finalSrc: finalPath, SvgComponent: null, internalClass: raw?.svgClassName || '' };
    }

    const isSvgObj = raw && typeof raw === 'object' && (raw.react || raw.React);
    if (isSvgObj) {
      return { 
        finalSrc:String(raw || ''), 
        SvgComponent: raw.react || raw.React,
        internalClass: raw.svgClassName || ''
      };
    }

    
    return { finalSrc: finalPath, SvgComponent: null, internalClass: raw?.svgClassName  };
  }, [src, epiImagesSet, folder]);
};


